import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {
	ReportVoyagePointAveragesLazy
} from "@containers/reports/readyReports/reportVoyagePointAverages/ReportVoyagePointAverages.lazy";

const ReportVoyagePointAveragesPage = () => {
	return (
		<PageLayout>
			<Suspense
				fallback={<SpinnerCustom/>}
			>
				<ReportVoyagePointAveragesLazy/>
			</Suspense>
		</PageLayout>
	);
};

export default ReportVoyagePointAveragesPage;